import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionEntry, LazyCatalogOrderForm, LazyCollapsableText, LazyContactForm, LazyFoldableText, LazyGoogleForm, LazyLookbook, LazyNewsletterSubscription, LazyNewsletterSubscriptionNew, LazyNewsletterUnsubscribe, LazyNewsletterUnsubscribeTransaction, LazyParagraph, LazyScreenReaderOnlyText, LazySizeTable, LazyStory, LazyAdvantagePage, LazyAdvantageProduct, LazyCampaignTeaser, LazyCategoryIconCarousel, LazyCategoryTeaser, LazyCategoryTeaserGrid, LazyCtaButton, LazyCmsText, LazyFeature, LazyFeatureList, LazyColumn, LazyGrid, LazyGridFixSize, LazyHeroBanner, LazyHeroBannerSlider, LazyIconSlider, LazyIconSliderSlide, LazyImageText, LazyImageTextGrid, LazyConstructionPage, LazyContentPage, LazyContentPageHeader, LazyListingPage, LazyPage, LazyBlogOverview, LazyCMSLink, LazyRichTextLink, LazyScrollableLinkList, LazyListingDisruptor, LazyAssetImage, LazyCmsImage, LazyInteractableImage, LazyInteractableVideo, LazyVideo, LazyVimeoVideo, LazyYouTubeVideo, LazyNavigationItem, LazyProduct, LazyProductSlider, LazySlideShow, LazyStage, LazyStageButton, LazyStageHeadline, LazyStageKicker, LazyStageSlide, LazyCmsImages, LazyBannerValantic, LazyIconHearth, LazyIconLogin, LazyIconShoppingCartMobileNav, LazyIconShoppingCart, LazyIconAj, LazyIconArrowDown, LazyIconArrowLeft, LazyIconArrowRightBlackM, LazyIconArrowRightWhiteM, LazyIconArrowRight, LazyIconArrowTrueDown, LazyIconArrowUp, LazyIconBack, LazyIconBasket, LazyIconBurger, LazyIconCareBleach, LazyIconCareBleachNoBleach, LazyIconCareBleachNonChlorineBleach, LazyIconCareCleanFOnlyDelicate, LazyIconCareCleanFOnly, LazyIconCareCleanNoDryClean, LazyIconCareCleanNoWetClean, LazyIconCareCleanPOnlyDelicate, LazyIconCareCleanPOnly, LazyIconCareCleanWetCleanDelicate, LazyIconCareCleanWetCleanVeryDelicate, LazyIconCareCleanWetClean, LazyIconCareDryNoTumbleDry, LazyIconCareDryTumbleDryLowTemp, LazyIconCareDryTumbleDryMediumTemp, LazyIconCareIronHighTemp, LazyIconCareIronLowTemp, LazyIconCareIronMediumTemp, LazyIconCareIronNoIron, LazyIconCareWash30DegreeDelicate, LazyIconCareWash30DegreeVeryDelicate, LazyIconCareWash30Degree, LazyIconCareWash40DegreeDelicate, LazyIconCareWash40DegreeVeryDelicate, LazyIconCareWash40Degree, LazyIconCareWash60DegreeDelicate, LazyIconCareWash60Degree, LazyIconCareWash95Degree, LazyIconCareWashHandWash, LazyIconCareWashNoWash, LazyIconCheckGreen, LazyIconCheck, LazyIconCheckboxAct, LazyIconCheckboxDisAct, LazyIconCheckboxDis, LazyIconCheckbox, LazyIconCheckmark, LazyIconCircleGreen, LazyIconCloseS, LazyIconClose, LazyIconCoatHanger, LazyIconCollect, LazyIconCross, LazyIconDate, LazyIconDeliveryTruck, LazyIconDelivery, LazyIconDifDeliv, LazyIconDoc, LazyIconDown, LazyIconDownload, LazyIconDropdown, LazyIconEmptyCart, LazyIconErrorX, LazyIconError, LazyIconEyeAbleIcon, LazyIconEyeCrossed, LazyIconEye, LazyIconEyeable, LazyIconFacebook, LazyIconFb, LazyIconFilter, LazyIconFooterLogo, LazyIconFooterCarrierBpost, LazyIconFooterCarrierBring, LazyIconFooterCarrierColissimo, LazyIconFooterCarrierDhl, LazyIconFooterCarrierEvri, LazyIconFooterCarrierLaposte, LazyIconFooterCarrierPostAt, LazyIconFooterCarrierPostCh, LazyIconFooterCarrierPostNl, LazyIconFooterCarrierPosti, LazyIconFooterPaymentBancontact, LazyIconFooterPaymentCartesBancaires, LazyIconFooterPaymentIdeal, LazyIconFooterPaymentMastercard, LazyIconFooterPaymentPaypalInstant, LazyIconFooterPaymentVisa, LazyIconFooterSecurityFevad, LazyIconFooterSecurityHandelsverbandAt, LazyIconFooterSecurityRpj, LazyIconFooterSecuritySv, LazyIconFooterSecuritySwissOnline, LazyIconFooterSecurityThuiswinkel, LazyIconFooterSecurityTrustEcommerceEurope, LazyIconFreeAdviceMobile, LazyIconFreeAdvice, LazyIconFreeReturnsMobile, LazyIconFreeReturns, LazyIconFunctionIcons100prozentAlpaka, LazyIconFunctionIcons100prozentBaumwolle, LazyIconFunctionIcons100prozentKaschmir, LazyIconFunctionIcons100prozentMerino, LazyIconFunctionIcons100prozentWolle, LazyIconFunctionIcons2WegeReissverschluss, LazyIconFunctionIcons2WegeStretch, LazyIconFunctionIcons3In1, LazyIconFunctionIcons4WegeStretch, LazyIconFunctionIconsAllwettertauglich, LazyIconFunctionIconsAtmungsaktiv, LazyIconFunctionIconsBeiLeichterInkontinenz, LazyIconFunctionIconsBeiMittlererInkontinenz, LazyIconFunctionIconsBeiStarkerInkontinenz, LazyIconFunctionIconsBuegelfrei, LazyIconFunctionIconsBuegellos, LazyIconFunctionIconsClassicFormCarla, LazyIconFunctionIconsComfortFormAnna, LazyIconFunctionIconsDefault, LazyIconFunctionIconsDetailsOnline, LazyIconFunctionIconsDoppelpack, LazyIconFunctionIconsDoppelverschluss, LazyIconFunctionIconsEchtleder, LazyIconFunctionIconsEmpfehlenswertBeiLangemSitzen, LazyIconFunctionIconsFederleicht, LazyIconFunctionIconsFeuchtigkeitsregulierend, LazyIconFunctionIconsFormbestaendig, LazyIconFunctionIconsFuerJedeJahreszeit, LazyIconFunctionIconsFussspitzeHandkettelt, LazyIconFunctionIconsGefuettertePads, LazyIconFunctionIconsGoodCashmere2, LazyIconFunctionIconsGoodCashmerePremium1, LazyIconFunctionIconsHerausnehmbarePads, LazyIconFunctionIconsKapuzeAbtrennbar, LazyIconFunctionIconsKomfortTraegerBreiteTraeger, LazyIconFunctionIconsKrempelbar, LazyIconFunctionIconsLeichtWaermend, LazyIconFunctionIconsMehrfachpack, LazyIconFunctionIconsMinimizer, LazyIconFunctionIconsMitAlpaka, LazyIconFunctionIconsMitBaumwolle, LazyIconFunctionIconsMitBiobaumwolle, LazyIconFunctionIconsMitBuegel, LazyIconFunctionIconsMitKaschmir, LazyIconFunctionIconsMitMerino, LazyIconFunctionIconsMitRecyceltemRohstoff, LazyIconFunctionIconsMitSchurwolle, LazyIconFunctionIconsMitWolle, LazyIconFunctionIconsModal, LazyIconFunctionIconsNachhaltig, LazyIconFunctionIconsNahtlos, LazyIconFunctionIconsNichtSichtbar, LazyIconFunctionIconsPflegeleicht, LazyIconFunctionIconsReflektierend, LazyIconFunctionIconsRundumDehnbundLouisa, LazyIconFunctionIconsRundumDehnbund, LazyIconFunctionIconsSchnelltrocknend, LazyIconFunctionIconsShaping, LazyIconFunctionIconsSoftTouch, LazyIconFunctionIconsStarkWaermend, LazyIconFunctionIconsStuetzendUndDurchblutungsfoerdernd, LazyIconFunctionIconsTeilDehnbundMartha, LazyIconFunctionIconsThermo, LazyIconFunctionIconsTrocknergeeignet, LazyIconFunctionIconsTwinset, LazyIconFunctionIconsUvSchutz, LazyIconFunctionIconsVerdeckterReissverschluss, LazyIconFunctionIconsVerstaerkteBauchpartie, LazyIconFunctionIconsVerstellbareTraeger, LazyIconFunctionIconsViskose, LazyIconFunctionIconsVorderverschluss, LazyIconFunctionIconsWaermend, LazyIconFunctionIconsWaermeregulierend, LazyIconFunctionIconsWaschmaschinengeeignet, LazyIconFunctionIconsWasserAbweisend, LazyIconFunctionIconsWendejacke, LazyIconFunctionIconsWindabweisend, LazyIconFunctionIconsZusaetzlicheTaschen, LazyIconFunctionIconsZweiteilerV1, LazyIconFunctionIconsZweiteilerV2, LazyIconGerman, LazyIconGlobe, LazyIconGoogleMaps, LazyIconHeartFull, LazyIconHeartMobileNav, LazyIconHeart, LazyIconInfo, LazyIconInformation, LazyIconInstagram, LazyIconInvoice, LazyIconLeft, LazyIconLinkedin, LazyIconLock, LazyIconLoginMobileNav, LazyIconMail, LazyIconMeasuringTape, LazyIconMinus, LazyIconOrder, LazyIconPaginationArrowLeft, LazyIconPaginationArrowRight, LazyIconPayback, LazyIconPaymentProtection, LazyIconPaymentDinersclub, LazyIconPaymentDiscover, LazyIconPaymentIdeal, LazyIconPaymentKlarna, LazyIconPaymentLastschrift, LazyIconPaymentMastercard, LazyIconPaymentPaypal, LazyIconPaymentRatepay, LazyIconPaymentSofort, LazyIconPaymentVisa, LazyIconPaypalLogo, LazyIconPen, LazyIconPhone, LazyIconPinterest, LazyIconPlus, LazyIconPurchaseOnInvoiceMobile, LazyIconPurchaseOnInvoice, LazyIconRadioOff, LazyIconRadioOn, LazyIconReset, LazyIconReturn, LazyIconRight, LazyIconSameDeliv, LazyIconSearch, LazyIconSince1991Mobile, LazyIconSince1991, LazyIconSpinner, LazyIconSsl, LazyIconStopwatch, LazyIconSuccess, LazyIconTrash, LazyIconUiArrowLeft, LazyIconUiArrowRight, LazyIconUiBack, LazyIconUiBacktotop, LazyIconUiBasket, LazyIconUiBurger, LazyIconUiCheckmark, LazyIconUiChevron, LazyIconUiClose, LazyIconUiCollapse, LazyIconUiDropdown, LazyIconUiExpand, LazyIconUiList, LazyIconUiMinus, LazyIconUiPlus, LazyIconUiSearch, LazyIconUiSocialFacebook, LazyIconUiSocialInstagram, LazyIconUiSocialPinterest, LazyIconUiSocialYoutube, LazyIconUiWishlistFilled, LazyIconUiWishlist, LazyIconUiZoomIn, LazyIconUiZoomOut, LazyIconUp, LazyIconUpdownGray, LazyIconUpdown, LazyIconUserSecondary, LazyIconXCircle, LazyIconYoutube } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionEntry", LazyAccordionEntry],
["CatalogOrderForm", LazyCatalogOrderForm],
["CollapsableText", LazyCollapsableText],
["ContactForm", LazyContactForm],
["FoldableText", LazyFoldableText],
["GoogleForm", LazyGoogleForm],
["Lookbook", LazyLookbook],
["NewsletterSubscription", LazyNewsletterSubscription],
["NewsletterSubscriptionNew", LazyNewsletterSubscriptionNew],
["NewsletterUnsubscribe", LazyNewsletterUnsubscribe],
["NewsletterUnsubscribeTransaction", LazyNewsletterUnsubscribeTransaction],
["Paragraph", LazyParagraph],
["ScreenReaderOnlyText", LazyScreenReaderOnlyText],
["SizeTable", LazySizeTable],
["Story", LazyStory],
["AdvantagePage", LazyAdvantagePage],
["AdvantageProduct", LazyAdvantageProduct],
["CampaignTeaser", LazyCampaignTeaser],
["CategoryIconCarousel", LazyCategoryIconCarousel],
["CategoryTeaser", LazyCategoryTeaser],
["CategoryTeaserGrid", LazyCategoryTeaserGrid],
["CtaButton", LazyCtaButton],
["CmsText", LazyCmsText],
["Feature", LazyFeature],
["FeatureList", LazyFeatureList],
["Column", LazyColumn],
["Grid", LazyGrid],
["GridFixSize", LazyGridFixSize],
["HeroBanner", LazyHeroBanner],
["HeroBannerSlider", LazyHeroBannerSlider],
["IconSlider", LazyIconSlider],
["IconSliderSlide", LazyIconSliderSlide],
["ImageText", LazyImageText],
["ImageTextGrid", LazyImageTextGrid],
["ConstructionPage", LazyConstructionPage],
["ContentPage", LazyContentPage],
["ContentPageHeader", LazyContentPageHeader],
["ListingPage", LazyListingPage],
["Page", LazyPage],
["BlogOverview", LazyBlogOverview],
["CMSLink", LazyCMSLink],
["RichTextLink", LazyRichTextLink],
["ScrollableLinkList", LazyScrollableLinkList],
["ListingDisruptor", LazyListingDisruptor],
["AssetImage", LazyAssetImage],
["CmsImage", LazyCmsImage],
["InteractableImage", LazyInteractableImage],
["InteractableVideo", LazyInteractableVideo],
["Video", LazyVideo],
["VimeoVideo", LazyVimeoVideo],
["YouTubeVideo", LazyYouTubeVideo],
["NavigationItem", LazyNavigationItem],
["Product", LazyProduct],
["ProductSlider", LazyProductSlider],
["SlideShow", LazySlideShow],
["Stage", LazyStage],
["StageButton", LazyStageButton],
["StageHeadline", LazyStageHeadline],
["StageKicker", LazyStageKicker],
["StageSlide", LazyStageSlide],
["CmsImages", LazyCmsImages],
["BannerValantic", LazyBannerValantic],
["IconHearth", LazyIconHearth],
["IconLogin", LazyIconLogin],
["IconShoppingCartMobileNav", LazyIconShoppingCartMobileNav],
["IconShoppingCart", LazyIconShoppingCart],
["IconAj", LazyIconAj],
["IconArrowDown", LazyIconArrowDown],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRightBlackM", LazyIconArrowRightBlackM],
["IconArrowRightWhiteM", LazyIconArrowRightWhiteM],
["IconArrowRight", LazyIconArrowRight],
["IconArrowTrueDown", LazyIconArrowTrueDown],
["IconArrowUp", LazyIconArrowUp],
["IconBack", LazyIconBack],
["IconBasket", LazyIconBasket],
["IconBurger", LazyIconBurger],
["IconCareBleach", LazyIconCareBleach],
["IconCareBleachNoBleach", LazyIconCareBleachNoBleach],
["IconCareBleachNonChlorineBleach", LazyIconCareBleachNonChlorineBleach],
["IconCareCleanFOnlyDelicate", LazyIconCareCleanFOnlyDelicate],
["IconCareCleanFOnly", LazyIconCareCleanFOnly],
["IconCareCleanNoDryClean", LazyIconCareCleanNoDryClean],
["IconCareCleanNoWetClean", LazyIconCareCleanNoWetClean],
["IconCareCleanPOnlyDelicate", LazyIconCareCleanPOnlyDelicate],
["IconCareCleanPOnly", LazyIconCareCleanPOnly],
["IconCareCleanWetCleanDelicate", LazyIconCareCleanWetCleanDelicate],
["IconCareCleanWetCleanVeryDelicate", LazyIconCareCleanWetCleanVeryDelicate],
["IconCareCleanWetClean", LazyIconCareCleanWetClean],
["IconCareDryNoTumbleDry", LazyIconCareDryNoTumbleDry],
["IconCareDryTumbleDryLowTemp", LazyIconCareDryTumbleDryLowTemp],
["IconCareDryTumbleDryMediumTemp", LazyIconCareDryTumbleDryMediumTemp],
["IconCareIronHighTemp", LazyIconCareIronHighTemp],
["IconCareIronLowTemp", LazyIconCareIronLowTemp],
["IconCareIronMediumTemp", LazyIconCareIronMediumTemp],
["IconCareIronNoIron", LazyIconCareIronNoIron],
["IconCareWash30DegreeDelicate", LazyIconCareWash30DegreeDelicate],
["IconCareWash30DegreeVeryDelicate", LazyIconCareWash30DegreeVeryDelicate],
["IconCareWash30Degree", LazyIconCareWash30Degree],
["IconCareWash40DegreeDelicate", LazyIconCareWash40DegreeDelicate],
["IconCareWash40DegreeVeryDelicate", LazyIconCareWash40DegreeVeryDelicate],
["IconCareWash40Degree", LazyIconCareWash40Degree],
["IconCareWash60DegreeDelicate", LazyIconCareWash60DegreeDelicate],
["IconCareWash60Degree", LazyIconCareWash60Degree],
["IconCareWash95Degree", LazyIconCareWash95Degree],
["IconCareWashHandWash", LazyIconCareWashHandWash],
["IconCareWashNoWash", LazyIconCareWashNoWash],
["IconCheckGreen", LazyIconCheckGreen],
["IconCheck", LazyIconCheck],
["IconCheckboxAct", LazyIconCheckboxAct],
["IconCheckboxDisAct", LazyIconCheckboxDisAct],
["IconCheckboxDis", LazyIconCheckboxDis],
["IconCheckbox", LazyIconCheckbox],
["IconCheckmark", LazyIconCheckmark],
["IconCircleGreen", LazyIconCircleGreen],
["IconCloseS", LazyIconCloseS],
["IconClose", LazyIconClose],
["IconCoatHanger", LazyIconCoatHanger],
["IconCollect", LazyIconCollect],
["IconCross", LazyIconCross],
["IconDate", LazyIconDate],
["IconDeliveryTruck", LazyIconDeliveryTruck],
["IconDelivery", LazyIconDelivery],
["IconDifDeliv", LazyIconDifDeliv],
["IconDoc", LazyIconDoc],
["IconDown", LazyIconDown],
["IconDownload", LazyIconDownload],
["IconDropdown", LazyIconDropdown],
["IconEmptyCart", LazyIconEmptyCart],
["IconErrorX", LazyIconErrorX],
["IconError", LazyIconError],
["IconEyeAbleIcon", LazyIconEyeAbleIcon],
["IconEyeCrossed", LazyIconEyeCrossed],
["IconEye", LazyIconEye],
["IconEyeable", LazyIconEyeable],
["IconFacebook", LazyIconFacebook],
["IconFb", LazyIconFb],
["IconFilter", LazyIconFilter],
["IconFooterLogo", LazyIconFooterLogo],
["IconFooterCarrierBpost", LazyIconFooterCarrierBpost],
["IconFooterCarrierBring", LazyIconFooterCarrierBring],
["IconFooterCarrierColissimo", LazyIconFooterCarrierColissimo],
["IconFooterCarrierDhl", LazyIconFooterCarrierDhl],
["IconFooterCarrierEvri", LazyIconFooterCarrierEvri],
["IconFooterCarrierLaposte", LazyIconFooterCarrierLaposte],
["IconFooterCarrierPostAt", LazyIconFooterCarrierPostAt],
["IconFooterCarrierPostCh", LazyIconFooterCarrierPostCh],
["IconFooterCarrierPostNl", LazyIconFooterCarrierPostNl],
["IconFooterCarrierPosti", LazyIconFooterCarrierPosti],
["IconFooterPaymentBancontact", LazyIconFooterPaymentBancontact],
["IconFooterPaymentCartesBancaires", LazyIconFooterPaymentCartesBancaires],
["IconFooterPaymentIdeal", LazyIconFooterPaymentIdeal],
["IconFooterPaymentMastercard", LazyIconFooterPaymentMastercard],
["IconFooterPaymentPaypalInstant", LazyIconFooterPaymentPaypalInstant],
["IconFooterPaymentVisa", LazyIconFooterPaymentVisa],
["IconFooterSecurityFevad", LazyIconFooterSecurityFevad],
["IconFooterSecurityHandelsverbandAt", LazyIconFooterSecurityHandelsverbandAt],
["IconFooterSecurityRpj", LazyIconFooterSecurityRpj],
["IconFooterSecuritySv", LazyIconFooterSecuritySv],
["IconFooterSecuritySwissOnline", LazyIconFooterSecuritySwissOnline],
["IconFooterSecurityThuiswinkel", LazyIconFooterSecurityThuiswinkel],
["IconFooterSecurityTrustEcommerceEurope", LazyIconFooterSecurityTrustEcommerceEurope],
["IconFreeAdviceMobile", LazyIconFreeAdviceMobile],
["IconFreeAdvice", LazyIconFreeAdvice],
["IconFreeReturnsMobile", LazyIconFreeReturnsMobile],
["IconFreeReturns", LazyIconFreeReturns],
["IconFunctionIcons100prozentAlpaka", LazyIconFunctionIcons100prozentAlpaka],
["IconFunctionIcons100prozentBaumwolle", LazyIconFunctionIcons100prozentBaumwolle],
["IconFunctionIcons100prozentKaschmir", LazyIconFunctionIcons100prozentKaschmir],
["IconFunctionIcons100prozentMerino", LazyIconFunctionIcons100prozentMerino],
["IconFunctionIcons100prozentWolle", LazyIconFunctionIcons100prozentWolle],
["IconFunctionIcons2WegeReissverschluss", LazyIconFunctionIcons2WegeReissverschluss],
["IconFunctionIcons2WegeStretch", LazyIconFunctionIcons2WegeStretch],
["IconFunctionIcons3In1", LazyIconFunctionIcons3In1],
["IconFunctionIcons4WegeStretch", LazyIconFunctionIcons4WegeStretch],
["IconFunctionIconsAllwettertauglich", LazyIconFunctionIconsAllwettertauglich],
["IconFunctionIconsAtmungsaktiv", LazyIconFunctionIconsAtmungsaktiv],
["IconFunctionIconsBeiLeichterInkontinenz", LazyIconFunctionIconsBeiLeichterInkontinenz],
["IconFunctionIconsBeiMittlererInkontinenz", LazyIconFunctionIconsBeiMittlererInkontinenz],
["IconFunctionIconsBeiStarkerInkontinenz", LazyIconFunctionIconsBeiStarkerInkontinenz],
["IconFunctionIconsBuegelfrei", LazyIconFunctionIconsBuegelfrei],
["IconFunctionIconsBuegellos", LazyIconFunctionIconsBuegellos],
["IconFunctionIconsClassicFormCarla", LazyIconFunctionIconsClassicFormCarla],
["IconFunctionIconsComfortFormAnna", LazyIconFunctionIconsComfortFormAnna],
["IconFunctionIconsDefault", LazyIconFunctionIconsDefault],
["IconFunctionIconsDetailsOnline", LazyIconFunctionIconsDetailsOnline],
["IconFunctionIconsDoppelpack", LazyIconFunctionIconsDoppelpack],
["IconFunctionIconsDoppelverschluss", LazyIconFunctionIconsDoppelverschluss],
["IconFunctionIconsEchtleder", LazyIconFunctionIconsEchtleder],
["IconFunctionIconsEmpfehlenswertBeiLangemSitzen", LazyIconFunctionIconsEmpfehlenswertBeiLangemSitzen],
["IconFunctionIconsFederleicht", LazyIconFunctionIconsFederleicht],
["IconFunctionIconsFeuchtigkeitsregulierend", LazyIconFunctionIconsFeuchtigkeitsregulierend],
["IconFunctionIconsFormbestaendig", LazyIconFunctionIconsFormbestaendig],
["IconFunctionIconsFuerJedeJahreszeit", LazyIconFunctionIconsFuerJedeJahreszeit],
["IconFunctionIconsFussspitzeHandkettelt", LazyIconFunctionIconsFussspitzeHandkettelt],
["IconFunctionIconsGefuettertePads", LazyIconFunctionIconsGefuettertePads],
["IconFunctionIconsGoodCashmere2", LazyIconFunctionIconsGoodCashmere2],
["IconFunctionIconsGoodCashmerePremium1", LazyIconFunctionIconsGoodCashmerePremium1],
["IconFunctionIconsHerausnehmbarePads", LazyIconFunctionIconsHerausnehmbarePads],
["IconFunctionIconsKapuzeAbtrennbar", LazyIconFunctionIconsKapuzeAbtrennbar],
["IconFunctionIconsKomfortTraegerBreiteTraeger", LazyIconFunctionIconsKomfortTraegerBreiteTraeger],
["IconFunctionIconsKrempelbar", LazyIconFunctionIconsKrempelbar],
["IconFunctionIconsLeichtWaermend", LazyIconFunctionIconsLeichtWaermend],
["IconFunctionIconsMehrfachpack", LazyIconFunctionIconsMehrfachpack],
["IconFunctionIconsMinimizer", LazyIconFunctionIconsMinimizer],
["IconFunctionIconsMitAlpaka", LazyIconFunctionIconsMitAlpaka],
["IconFunctionIconsMitBaumwolle", LazyIconFunctionIconsMitBaumwolle],
["IconFunctionIconsMitBiobaumwolle", LazyIconFunctionIconsMitBiobaumwolle],
["IconFunctionIconsMitBuegel", LazyIconFunctionIconsMitBuegel],
["IconFunctionIconsMitKaschmir", LazyIconFunctionIconsMitKaschmir],
["IconFunctionIconsMitMerino", LazyIconFunctionIconsMitMerino],
["IconFunctionIconsMitRecyceltemRohstoff", LazyIconFunctionIconsMitRecyceltemRohstoff],
["IconFunctionIconsMitSchurwolle", LazyIconFunctionIconsMitSchurwolle],
["IconFunctionIconsMitWolle", LazyIconFunctionIconsMitWolle],
["IconFunctionIconsModal", LazyIconFunctionIconsModal],
["IconFunctionIconsNachhaltig", LazyIconFunctionIconsNachhaltig],
["IconFunctionIconsNahtlos", LazyIconFunctionIconsNahtlos],
["IconFunctionIconsNichtSichtbar", LazyIconFunctionIconsNichtSichtbar],
["IconFunctionIconsPflegeleicht", LazyIconFunctionIconsPflegeleicht],
["IconFunctionIconsReflektierend", LazyIconFunctionIconsReflektierend],
["IconFunctionIconsRundumDehnbundLouisa", LazyIconFunctionIconsRundumDehnbundLouisa],
["IconFunctionIconsRundumDehnbund", LazyIconFunctionIconsRundumDehnbund],
["IconFunctionIconsSchnelltrocknend", LazyIconFunctionIconsSchnelltrocknend],
["IconFunctionIconsShaping", LazyIconFunctionIconsShaping],
["IconFunctionIconsSoftTouch", LazyIconFunctionIconsSoftTouch],
["IconFunctionIconsStarkWaermend", LazyIconFunctionIconsStarkWaermend],
["IconFunctionIconsStuetzendUndDurchblutungsfoerdernd", LazyIconFunctionIconsStuetzendUndDurchblutungsfoerdernd],
["IconFunctionIconsTeilDehnbundMartha", LazyIconFunctionIconsTeilDehnbundMartha],
["IconFunctionIconsThermo", LazyIconFunctionIconsThermo],
["IconFunctionIconsTrocknergeeignet", LazyIconFunctionIconsTrocknergeeignet],
["IconFunctionIconsTwinset", LazyIconFunctionIconsTwinset],
["IconFunctionIconsUvSchutz", LazyIconFunctionIconsUvSchutz],
["IconFunctionIconsVerdeckterReissverschluss", LazyIconFunctionIconsVerdeckterReissverschluss],
["IconFunctionIconsVerstaerkteBauchpartie", LazyIconFunctionIconsVerstaerkteBauchpartie],
["IconFunctionIconsVerstellbareTraeger", LazyIconFunctionIconsVerstellbareTraeger],
["IconFunctionIconsViskose", LazyIconFunctionIconsViskose],
["IconFunctionIconsVorderverschluss", LazyIconFunctionIconsVorderverschluss],
["IconFunctionIconsWaermend", LazyIconFunctionIconsWaermend],
["IconFunctionIconsWaermeregulierend", LazyIconFunctionIconsWaermeregulierend],
["IconFunctionIconsWaschmaschinengeeignet", LazyIconFunctionIconsWaschmaschinengeeignet],
["IconFunctionIconsWasserAbweisend", LazyIconFunctionIconsWasserAbweisend],
["IconFunctionIconsWendejacke", LazyIconFunctionIconsWendejacke],
["IconFunctionIconsWindabweisend", LazyIconFunctionIconsWindabweisend],
["IconFunctionIconsZusaetzlicheTaschen", LazyIconFunctionIconsZusaetzlicheTaschen],
["IconFunctionIconsZweiteilerV1", LazyIconFunctionIconsZweiteilerV1],
["IconFunctionIconsZweiteilerV2", LazyIconFunctionIconsZweiteilerV2],
["IconGerman", LazyIconGerman],
["IconGlobe", LazyIconGlobe],
["IconGoogleMaps", LazyIconGoogleMaps],
["IconHeartFull", LazyIconHeartFull],
["IconHeartMobileNav", LazyIconHeartMobileNav],
["IconHeart", LazyIconHeart],
["IconInfo", LazyIconInfo],
["IconInformation", LazyIconInformation],
["IconInstagram", LazyIconInstagram],
["IconInvoice", LazyIconInvoice],
["IconLeft", LazyIconLeft],
["IconLinkedin", LazyIconLinkedin],
["IconLock", LazyIconLock],
["IconLoginMobileNav", LazyIconLoginMobileNav],
["IconMail", LazyIconMail],
["IconMeasuringTape", LazyIconMeasuringTape],
["IconMinus", LazyIconMinus],
["IconOrder", LazyIconOrder],
["IconPaginationArrowLeft", LazyIconPaginationArrowLeft],
["IconPaginationArrowRight", LazyIconPaginationArrowRight],
["IconPayback", LazyIconPayback],
["IconPaymentProtection", LazyIconPaymentProtection],
["IconPaymentDinersclub", LazyIconPaymentDinersclub],
["IconPaymentDiscover", LazyIconPaymentDiscover],
["IconPaymentIdeal", LazyIconPaymentIdeal],
["IconPaymentKlarna", LazyIconPaymentKlarna],
["IconPaymentLastschrift", LazyIconPaymentLastschrift],
["IconPaymentMastercard", LazyIconPaymentMastercard],
["IconPaymentPaypal", LazyIconPaymentPaypal],
["IconPaymentRatepay", LazyIconPaymentRatepay],
["IconPaymentSofort", LazyIconPaymentSofort],
["IconPaymentVisa", LazyIconPaymentVisa],
["IconPaypalLogo", LazyIconPaypalLogo],
["IconPen", LazyIconPen],
["IconPhone", LazyIconPhone],
["IconPinterest", LazyIconPinterest],
["IconPlus", LazyIconPlus],
["IconPurchaseOnInvoiceMobile", LazyIconPurchaseOnInvoiceMobile],
["IconPurchaseOnInvoice", LazyIconPurchaseOnInvoice],
["IconRadioOff", LazyIconRadioOff],
["IconRadioOn", LazyIconRadioOn],
["IconReset", LazyIconReset],
["IconReturn", LazyIconReturn],
["IconRight", LazyIconRight],
["IconSameDeliv", LazyIconSameDeliv],
["IconSearch", LazyIconSearch],
["IconSince1991Mobile", LazyIconSince1991Mobile],
["IconSince1991", LazyIconSince1991],
["IconSpinner", LazyIconSpinner],
["IconSsl", LazyIconSsl],
["IconStopwatch", LazyIconStopwatch],
["IconSuccess", LazyIconSuccess],
["IconTrash", LazyIconTrash],
["IconUiArrowLeft", LazyIconUiArrowLeft],
["IconUiArrowRight", LazyIconUiArrowRight],
["IconUiBack", LazyIconUiBack],
["IconUiBacktotop", LazyIconUiBacktotop],
["IconUiBasket", LazyIconUiBasket],
["IconUiBurger", LazyIconUiBurger],
["IconUiCheckmark", LazyIconUiCheckmark],
["IconUiChevron", LazyIconUiChevron],
["IconUiClose", LazyIconUiClose],
["IconUiCollapse", LazyIconUiCollapse],
["IconUiDropdown", LazyIconUiDropdown],
["IconUiExpand", LazyIconUiExpand],
["IconUiList", LazyIconUiList],
["IconUiMinus", LazyIconUiMinus],
["IconUiPlus", LazyIconUiPlus],
["IconUiSearch", LazyIconUiSearch],
["IconUiSocialFacebook", LazyIconUiSocialFacebook],
["IconUiSocialInstagram", LazyIconUiSocialInstagram],
["IconUiSocialPinterest", LazyIconUiSocialPinterest],
["IconUiSocialYoutube", LazyIconUiSocialYoutube],
["IconUiWishlistFilled", LazyIconUiWishlistFilled],
["IconUiWishlist", LazyIconUiWishlist],
["IconUiZoomIn", LazyIconUiZoomIn],
["IconUiZoomOut", LazyIconUiZoomOut],
["IconUp", LazyIconUp],
["IconUpdownGray", LazyIconUpdownGray],
["IconUpdown", LazyIconUpdown],
["IconUserSecondary", LazyIconUserSecondary],
["IconXCircle", LazyIconXCircle],
["IconYoutube", LazyIconYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
